import Tile from './tile';

export class TwoUp {
  backgroundColor: string;
  separatorColor: string;
  items: Tile[];

  constructor(props: any) {
    this.backgroundColor = props.backgroundColor;
    this.separatorColor = props.separatorColor;
    this.items = props.itemsCollection?.items?.map((i: any) => new Tile(i));
  }
}

export default TwoUp;
